//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function DragOverlayFunction({ object }) {
  let description = object?.object?.display || "Function()"

  return <div className={myStyles.dragOverlyGeneral}>{description}</div>
}
